export default {
    imgUrl: "https://img.mobile.ag/",
}
